// src/redux/reducers/filterOptionsReducer.js

import {
  FETCH_FILTERS_REQUEST,
  FETCH_FILTERS_SUCCESS,
  FETCH_FILTERS_FAILURE,
  RESET_FILTERS
} from '../actions/filterActions';

const initialState = {
  loading: false,
  data: {
    categories: [],     // [{ cat_id, cat_name, … }, …]
    subcategories: [],  // [{ sub_cat_id, sub_cat_name, … }, …]
    sizes: [],          // [{ size_id, size_name, … }, …]
    colors: [],         // [{ id, color_name, shade }, …]
    tags: []            // [{ tag_name }, …]
  },
  error: null
};

export default function filterOptionsReducer(state = initialState, action) {
  switch (action.type) {
    case FETCH_FILTERS_REQUEST:
      return { ...state, loading: true, error: null };
    case FETCH_FILTERS_SUCCESS:
      return { loading: false, data: action.payload, error: null };
    case FETCH_FILTERS_FAILURE:
      return { loading: false, data: { ...initialState.data }, error: action.payload };
    case RESET_FILTERS:
      return { loading: false, data: { ...initialState.data }, error: action.payload };
    default:
      return state;
  }
}
